import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EuroSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EuroSVG;
